import React, { Component } from 'react';
import './../css/master.css';
import './../css/index.css';
import $ from 'jquery';
import axiosInstance from '../api/csAxios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 

var httpURL='';
class WeaverLogin extends Component {
	constructor(props){
		super(props);
		this.state ={
			loader:'none',
			opacity:1,
		}
	}
	
	login =()=> {
	  this.setState({loader:'block', opacity:0.5});
	  var queryString = require('querystring');
	  var usernametrim = document.getElementById('usr').value;
	  var passwordtrim = document.getElementById('pwd').value;
	  var username = $.trim(usernametrim);
	  var password = $.trim(passwordtrim);
	  
	  axiosInstance.post(httpURL+'/w/l/weaverlogin',
		queryString.stringify({'weaverEmail' : username, 'password' : password}), {withCredentials: true}
	  ).then(async (response)=> {
			if(response.data.SvcStatus === 'Success'){
				toast.success(response.data.SvcMsg);
				await localStorage.setItem('wtokenid', response.headers.tokenid)
				sessionStorage.setItem('weaverEmail', username);
				sessionStorage.setItem('weaverId', response.data.weaverId);
				setTimeout(function(){window.location.href = '/wvr/weaver';}.bind(this), 2000);
			}
			else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
	  }).catch((error)=> {
			toast.error("Service failed " + error);
	  });   
   }
  
  forGotPassword=()=>{
	var queryString = require('querystring');
	var username = document.getElementById('usr').value;
	if(username===""){
	toast.warning("Please enter email Id");
	return false;
	}
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.post(httpURL+'/w/l/forgotpassword',
		queryString.stringify({'weaverEmail' : username}),
	).then((response) =>{ 
		if(response.data.SvcStatus === "Success"){
			toast.success(response.data.SvcMsg);
		}
		else{
			toast.error(response.data.SvcMsg);
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=>{
		toast.error("Service failed "+error);
	});
  }
  
  enterLogin =(e)=> {
	  if(e.key === 'Enter'){
		  this.login();
	  }
  }
  
  render() {
	httpURL = window.httpURL;
	return (
      <div className="container bg-img" style={{paddingTop:100, boxSizing:'borderBox'}}>
        <ToastContainer autoClose={2000} hideProgressBar />
		<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
			<img src={require("../images/loader.gif")} alt="Loader..."/>
		</div> 
		<div className="loginFormDiv" style={{opacity:this.state.opacity}}>
			<h3 style={{textAlign:'center', color:'rgb(247,150,70)', marginTop:20}}>Weaver Login here</h3>
			<form id="loginForm">
				<div className="form-group input-group" style={{marginTop:40, marginBottom:40, width:'100%'}}>
				<span className="has-float-label">
					<input autoComplete="off"  type="text" className="form-control" id="usr" placeholder="Username" />
					<label htmlFor="usr">Username</label>
					</span>
				</div>
				<div className="form-group input-group" style={{marginTop:40, marginBottom:40, width:'100%'}}>
					<span className="has-float-label">
						<input type="password" className="form-control" id="pwd" onKeyPress={this.enterLogin} placeholder="Password" />
						<label htmlFor="pwd">Password</label>
					</span>
				</div>
				<div className="form-group" style={{marginTop:40, marginBottom:40, width:'100%'}}>
					<span onClick={this.forGotPassword} style={{fontSize:18, float:'right', color:'rgb(247,150,70)', textDecoration:'underline'}} id="forgotPwd">Forgot password</span>
				</div>
				<div style={{marginTop:100}} className="text-center">
					<button style={{width:90, height:35, fontSize:18}} type="button" className="btn btn-warning text-center" onClick={this.login} id="loginBtn">Login</button>
				</div>
			</form>
		</div>
	  </div>
    );
  }
}

export default WeaverLogin;
